import { Link } from 'react-router-dom';

export default function Nosotros() {
  return (
    <div className="page narrow">
      <div className="page-head"><p className="kicker">Sobre Kanel</p><h1>Hornear es nuestra forma de cuidarte</h1></div>
      <div className="about-img" style={{ backgroundImage: 'url(/gallery/kanel-03.jpg)' }} />
      <p className="prose">Kanel Bakery nace en Madrid de las ganas de hacer repostería casera, deliciosa y bonita: de esa que invita a hacer una pausa y disfrutar. Cheesecakes cremosos, cookies recién horneadas, dollies, tartas personalizadas y mucho cariño en cada detalle.</p>
      <p className="prose">Trabajamos por encargo, así que todo lo que recibes se hornea para ti. Tú eliges el sabor, el tamaño y el mensaje; nosotros ponemos las manos y el horno. Entregamos en Madrid, con recogida en obrador o envío a domicilio.</p>
      <div className="cta-band cta-band--soft">
        <h2>¿Empezamos tu pedido?</h2>
        <Link to="/carta" className="btn btn--primary">Ver la carta</Link>
      </div>
    </div>
  );
}
